import { render, staticRenderFns } from "./DataDictionary.vue?vue&type=template&id=40d77a2e&"
import script from "./DataDictionary.vue?vue&type=script&lang=js&"
export * from "./DataDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports